import { Text } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeOrderLineItemProps } from './types';

/**
 * OrderLineItem
 */
export const OrderLineItem: FunctionComponent<TypeOrderLineItemProps> = ({
  className = '',
  status,
  name,
  children,
}: TypeOrderLineItemProps) => {
  let orderStatus = 'a';

  switch (status) {
    case 'PROCESSING':
      orderStatus = 'success';
      break;
    case 'FAILED':
      orderStatus = 'error';
      break;
  }

  const translate = (val: any) => {
    switch (val) {
      case 'CANCELLED':
        return 'CANCELADO';
      case 'COMPLETED':
        return 'COMPLETADO';
      case 'FAILED':
        return 'FALLIDO';
      case 'ON_HOLD':
        return 'EN ESPERA';
      case 'PROCESSING':
        return 'PROCESANDO';
      case 'PENDING':
        return 'PENDIENTE';
      case 'REDSYS_PBANKT':
        return 'PENDIENTE TRANSFERENCIA';
      case 'REDSYS_PRE':
        return 'PREAUTORIZADO';
      case 'REFUNDED':
        return 'REEMBOLSADO';
      default:
        return val;
    }
  };

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <Text as="span" className="u-actions u-actions--link text-typo-tertiary">
        {name}
      </Text>
      <Text
        as="span"
        className="u-body u-body--s"
        style={
          status
            ? { color: `var(--tw-color-status-${orderStatus})` }
            : { color: `#000` }
        }
      >
        {translate(children)}
      </Text>
    </div>
  );
};
